import IframeContainer from "./features/iframe-container";
import './styles.css';


(() => {
    /**
     * Iframe Container - wraps page in iframe for SPA navigation
     */
    if ( ajaxpress_vars.settings.enable_navigation ) {
        IframeContainer()
    }
})()
